import useExperimentBucket from '~/hooks/common/experiments/useExperimentBucket';

export const QUALI_FACTORY_UPGRADES_NAME =
  'car-merch-ui-quali-factory-upgrades';

export default function useIsInFactoryUpgradesQualiExperiment(): boolean {
  return useExperimentBucket(QUALI_FACTORY_UPGRADES_NAME) === 'survey';
}
